import { Alert, Modal, notification } from "antd"
import { useState } from "react"
import { useMutation } from "react-query"
import PropertySelector, { PropertySelection } from "../PropertySelector/PropertySelector"
import { move, MovePreCheck, MoveRequest } from "./JobOperationsModel"

export type Props = {
  visible: boolean,
  onClose: () => void,
  jobId: number,
  precheck: MovePreCheck
}

const MoveJobModal = ({ visible, onClose, jobId, precheck }: Props) => {
  const [propertySelection, setPropertySelection] = useState<PropertySelection>()
  const moveMutation = useMutation((request: MoveRequest) => move(request), {
    onSuccess: () => {
      window.location.reload()
    },
    onError: (error: Error) => {
      notification.error({
        message: error.message
      })
    }
  })

  const handleOk = () => {
    if (propertySelection !== undefined) {
      moveMutation.mutate({
        jobId,
        newCustomerId: propertySelection.customerId,
        newPropertyId: propertySelection.propertyId
      })

      onClose()
    }
  }

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
      okButtonProps={{ disabled: propertySelection === undefined }}
      width={900}
      title="Move Job"
    >
      <PropertySelector onChange={setPropertySelection} />
      {precheck.consultCount > 0 &&
        <Alert type="warning" showIcon description={
          <>
            This job is attached to {precheck.consultCount} consultation{precheck.consultCount > 1 && 's'}.
            If you move the job, all consultations will be detached.
          </>}
        />
      }
    </Modal>
  )
}
export default MoveJobModal
